module.exports = __webpack_public_path__ + "c434269fffdd80cf3f9285fca0bda004.pdf";